
export default function Footer() {
  const currentYear = '2026';

  const quickLinks = [
    { name: 'Sobre', href: '#sobre' },
    { name: 'Serviços', href: '#servicos' },
    { name: 'Experiência', href: '#experiencia' },
    { name: 'Contato', href: '#contato' }
  ];

  const services = [
    'PPCP',
    'Projetos & Obras',
    'Segurança do Trabalho',
    'Consultoria Técnica'
  ];

  const scrollToSection = (sectionId: string) => {
    document.getElementById(sectionId.replace('#', ''))?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-12">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold mb-6">
              Regiane <span className="text-yellow-500">Fialho</span>
            </h3>
            <p className="text-gray-300 mb-6 leading-relaxed">
              Engenharia Civil especializada em PPCP, Projetos & Obras e Segurança do Trabalho. 
              Soluções técnicas para empresas e construtoras.
            </p>
            <div className="flex items-center gap-2 text-gray-300">
              <i className="ri-map-pin-line text-yellow-500"></i>
              <span>Maringá, Paraná</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Links Rápidos</h4>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-gray-300 hover:text-yellow-500 transition-colors cursor-pointer"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Serviços</h4>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index} className="text-gray-300">
                  {service}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold mb-6">Contato</h4>
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <i className="ri-mail-line text-yellow-500"></i>
                <span className="text-gray-300">contato@regianefialho.com.br</span>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-whatsapp-line text-yellow-500"></i>
                <span className="text-gray-300">(44) 99992-1632</span>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-linkedin-line text-yellow-500"></i>
                <a 
                  href="https://www.linkedin.com/in/regiane-f-a2a802ab" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-yellow-500 transition-colors"
                >
                  LinkedIn
                </a>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-instagram-line text-yellow-500"></i>
                <a 
                  href="https://www.instagram.com/engregianefialho/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-yellow-500 transition-colors"
                >
                  Instagram
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {currentYear} Regiane Fialho - Engenharia Civil. Todos os direitos reservados.
            </p>
            <div className="flex items-center gap-6 text-sm">
              <button className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                Política de Privacidade
              </button>
              <span className="text-gray-600">•</span>
              <span className="text-gray-400">Maringá, PR</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
